import Visualize from './Visualize';
import './Visualize.scss';

export default Visualize;